<template>
  <a-modal width="60%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>选择商家</b>
    </a-divider>
    <a-tabs v-model:activeKey="activeKey" @change="changeTab">
      <a-tab-pane key="first" tab="搜索"></a-tab-pane>
      <a-tab-pane key="second" tab="按ID批量选择"></a-tab-pane>
    </a-tabs>

    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper" v-if="activeKey==='first' ">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="商家名称" prop="merchantName">
                <a-input v-model="queryParam.merchantName" :maxLength="32" :placeholder="$t('请输入')+'商家名称'" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="经营类型" prop="selfType">
                <a-select :placeholder="$t('请选择')+'经营类型'" v-model="queryParam.selfType" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.SelfTypeEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div style="margin-bottom: 16px" v-if="activeKey==='first'">
        <a-button type="primary" :loading="loading" @click="selectGoodsAll">
          全选
        </a-button>
        <a-button type="primary" :disabled="this.selectedRowKeys.length <= 0" :loading="loading" @click="reload">
          取消全部
        </a-button>


        <span style="margin-left: 8px">
        <template v-if="this.merchantSelectedList.length > 0" >
          {{ `已选商家 ${merchantSelectedList.length} 条` }}
        </template>
        <a-button style="float: right; padding: 3px 0" type="text" @click="emptyDelete">清空</a-button>
      </span>
      </div>
      <div>
        <a-row>
          <a-col :span="16" v-if="activeKey==='first'">
            <!-- 数据展示 -->
            <a-table
              :loading="loading"
              :size="tableSize"
              rowKey="id"
              :columns="columns"
              :data-source="list"
              :row-selection="{ selectedRowKeys: selectedRowKeys, type: 'checkbox', onSelect: onSelect,onSelectAll:onSelectAll}"
              :pagination="false"
              :bordered="tableBordered">
              <template slot="merchantLogo" slot-scope="text, record">
                <div>
                  <img v-if="record.merchantLogo" :src="record.merchantLogo" style="width:50px;height:50px;" @click="handleRecordPreview(record.merchantLogo)" alt="none"/>
                </div>
              </template>
            </a-table>
            <!-- 分页 -->
            <a-pagination
              class="ant-table-pagination"
              show-size-changer
              show-quick-jumper
              :pageSizeOptions="pageSizeOptions"
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :showTotal="total => getTotal(total)"
              @showSizeChange="onShowSizeChange"
              @change="changeSize"
            />
            <a-button type="primary"  icon="a-icon-search" @click="addListFirst" :disabled="this.selectedRowKeys.length <= 0" :loading="loading" >
              添加
            </a-button>
          </a-col>
          <a-col :span="16" v-if="activeKey==='second'">
            <div class="prods-select-body left"  style="position: relative;">
              <a-input
                type="textarea"
                placeholder="请输入商家ID,多商家使用换行分隔，每次最多可添加2000个商家"
                v-model="idText"
                maxlength="100000"
                :rows="28"
                show-word-limit
                style="height: 600px;"
                class="textarea">
              </a-input>
              <a-button type="primary" @click="addListSecond" icon="a-icon-search" style="position: absolute;bottom: 0;right: 0;">添加</a-button>
            </div>
          </a-col>
          <a-col :span="8">
            <a-card style="margin: 0" :bordered="true">
              <div>
                <a-row>
                  <a-col :span="6"><span style="font-size: 16px">商家编号</span> </a-col>
                  <a-col :span="18"><span style="font-size: 16px">商家名称</span> </a-col>
                </a-row>
              </div>
              <div class="text item">
                <a-row v-for="(item, index) in merchantSelectedList" :key="index">
                  <a-col :span="6">{{ item.id }}</a-col>
                  <a-col :span="16" style="width:150px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                    {{ item.merchantName }}
                  </a-col>
                  <a-col :span="2" style="float: right;">
                    <a-icon type="close" @click="deleteList(item, index)" />
                  </a-col>
                </a-row>
              </div>
            </a-card>
          </a-col>
        </a-row>
      </div>

    </a-card>
  </a-modal>
</template>

<script>
import {listSelectMerchant, pageSelectMerchant} from '@/api/merchant/merchantMerchant'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import Editor from "@/components/Editor/Editor";
import {tableMixin} from '@/store/table-mixin'
import textArea from "@/components/TextArea";


export default {
  name: 'CheckboxGoodsSelectForm',
  props: {},
  components: {
    Editor,
    CustomDictTag,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      idText: '',
      activeKey: 'first',
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      merchantSelectedList: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      open: false,
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        merchantName: undefined,
        merchantStatus: undefined,
        selfType: undefined,
        businessType: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '编号',
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: '商家logo',
          dataIndex: 'merchantLogo',
          scopedSlots: {customRender: 'merchantLogo'},
          ellipsis: true,
          align: 'center'
        },
        {
          title: '商家名称',
          dataIndex: 'merchantName',
          ellipsis: true,
          align: 'center'
        },
      ]
    };
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.resetQuery()
      this.merchantSelectedList = []
      this.textarea = ''
    },
    reload() {
      this.selectedRowKeys = [];
      this.selectedRows=[];
    },
    emptyDelete() {
      this.merchantSelectedList = []
      this.selectedRows = []
      this.selectedRowKeys = [];
    },
    deleteList(row, index) {
      this.merchantSelectedList.splice(index, 1);
    },
    selectGoodsAll() {
      //查询该条件下所有的商品,
      listSelectMerchant(this.queryParam).then(response => {
        this.selectedRows = response.data;
        this.selectedRowKeys = this.selectedRows.map(e => e.id);
        response.data.forEach(selected => {
          //如果merchantSelectedList中没有这个商品,则添加 ,有就跳过
          if (this.merchantSelectedList.findIndex(item => item.id === selected.id) === -1) {
            this.merchantSelectedList.push(selected)
          }
        });
        this.onOk()
      })

      this.selectedRowKeys = [];
      this.selectedRows=[];
    },
    /**
     *
     * @param records
     */
    openGoods( records) {
      if (records) {
        console.log('带过来的key',records)
        // 对源数据深度克隆
        const cloneData = JSON.parse(JSON.stringify(records))
        this.selectedRows = cloneData;
        this.selectedRowKeys = this.selectedRows.map(item => item.id);
        this.queryParam.orderByGoodsIdList = this.selectedRowKeys;
        this.merchantSelectedList = records;
      }
      this.getList()
      this.open = true;
    },
    onOk() {
      //判断有没有选择,拿到列表里选择的
      this.open = false
      this.$emit('merchantSelected', this.merchantSelectedList)
      this.resetQuery()
      this.merchantSelectedList = []
      this.idText = ''
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.resetQuery()
      this.merchantSelectedList = []
      this.idText = ''
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询明星列表 */
    getList () {
      this.loading = true
      pageSelectMerchant(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.selectedRowKeys= [];
      this.selectedRows= [];
      this.queryParam = {
        merchantName: undefined,
        selfType: undefined,
        merchantStatus: undefined,
        businessType: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeTab(index) {
      if (index == null) {
        index = undefined
      }
      this.activeKey = index
    },
    onSelect (record, selected, selectedRows) {
      //如果是选中,则判断是限制数量
      if (selected) {
        this.selectedRows.push(record)
      } else {
        this.selectedRows = this.selectedRows.filter(e => e.id !== record.id);
      }
      this.ids = this.selectedRows.map(item => item.id)
      this.selectedRowKeys = this.ids;
    },
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        this.selectedRows =this.selectedRows.concat(changeRows)
      } else {
        let selectIds = changeRows.map(e => e.id);
        this.selectedRows = this.selectedRows.filter(e => !selectIds.includes(e.id));
      }
      this.ids = this.selectedRows.map(item => item.id)
      this.selectedRowKeys = this.ids;
    },
    addListFirst() {
      //将selectedRows中的商品添加到merchantSelectedList列表中,根据id 判断如果 merchantSelectedList 有相同的就跳过
      this.selectedRows.forEach(selected => {
        //如果merchantSelectedList中没有这个商品,则添加 ,有就跳过
        if (this.merchantSelectedList.findIndex(item => item.id === selected.id) === -1) {
          this.merchantSelectedList.push(selected)
        }
      });
      // 取消表格的勾选
      this.reload()
    },

    addListSecond() {
      let param = {"idText": this.idText}
      listSelectMerchant(param).then(response => {
        this.selectedRows = response.data;
        this.selectedRowKeys = this.selectedRows.map(e => e.id);
        response.data.forEach(selected => {
          //如果merchantSelectedList中没有这个商品,则添加 ,有就跳过
          if (this.merchantSelectedList.findIndex(item => item.id === selected.id) === -1) {
            this.merchantSelectedList.push(selected)
          }
        });
      });
      // 取消表格的勾选
      this.reload();
    },

    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
  }
}
</script>

<style scoped>
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}
</style>
